import React, { useState, useEffect } from 'react'
import { useDashboard } from '../../DashboardContext'
import { useAuth } from '../../../auth/AuthContext'

function YourListing() {

  // Get current user and logout from auth
  const { currentUser } = useAuth();

  return (
    <>
      <div className='w-max'>
      <h2 className='font-bold text-3xl'>Your Listing</h2>
        <p className='opacity-50'>View and edit your listing</p>
      </div>
    </>
  )
}

export default YourListing
